module.exports = __webpack_public_path__ + "static/media/tajpur-sea-beach.beccc8c4.jpg";